import React, { useState, useEffect } from "react"
import Api from "../../../../_helpers/Api"
import Skeleton from "react-loading-skeleton"
import NoDataFound from "../../../partials/NoDataFound"
import { trans } from "../../../../_providers/Translation"
import ServicingOptions from "./ServicingOptions"
import moment from "moment"
import Pagination from "@/components/Pagination"
import checkIcon from "@/assets/img/icons/check.png"
import crossIcon from "@/assets/img/icons/cross.svg"
import ServicingFilter from "./ServicingFilter"
import { useHistory, useLocation } from "react-router-dom"

let timeout

export default function ServicingList({ handleEdit, handleDelete, refresh }) {
  const location = useLocation()
  const history = useHistory()

  const searchParams = new URLSearchParams(location.search)

  const page = searchParams.get("page") || 1
  const name = searchParams.get("name") || ""
  const categoryId = searchParams.get("category_id") || ""
  const brandId = searchParams.get("brand_id") || ""
  const model = searchParams.get("model") || ""
  const contractorId = searchParams.get("contractor_id") || ""

  const [data, setData] = useState({
    loading: true,
    data: [],
    page: 1,
    pages: 0,
    update: false,
    filter: {},
    setFilter: false,
  })

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      page: page,
      filter: {
        ...prev.filter,
        name: name,
        category_id: categoryId,
        brand_id: brandId,
        model: model,
        contractor_id: contractorId,
      },
      update: new Date().getTime(),
    }))
  }, [page, name, categoryId, brandId, model, contractorId])

  useEffect(() => {
    if (data.setFilter) {
      searchParams.set("page", data.page)

      Object.entries(data.filter).map((filter) => {
        // if (filter[1]) {
        searchParams.set(filter[0], filter[1])
        // }
      })

      let url = "?" + searchParams.toString()

      history.push(url)
    }
  }, [data.setFilter])

  useEffect(() => {
    loadServicing()
  }, [refresh, data.update])

  const loadServicing = () => {
    setData((prev) => ({
      ...prev,
      loading: true,
    }))

    let url = "contractors/appliance-servicing?page=" + data.page

    Object.entries(data.filter).map((filter) => {
      url += "&" + filter[0] + "=" + filter[1]
    })

    Api.get(url)
      .then((res) => {
        setData((prev) => ({
          ...prev,
          loading: false,
          data: res.data.items,
          pages: res.data.pages,
        }))
      })
      .catch(() => {
        setData((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const handlePage = (page) => {
    setData((prev) => ({
      ...prev,
      page: page.selected + 1,
      update: new Date().getTime(),
    }))
  }

  //Search
  const handleSearch = (key, val) => {
    clearTimeout(timeout)

    setData((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [key]: val,
      },
    }))

    timeout = setTimeout(() => {
      setData((prev) => ({
        ...prev,
        page: 1,
        setFilter: new Date().getTime(),
      }))
    }, 300)
  }

  return (
    <div className="pannel">
      <h3>Списък с уреди за сервизиране</h3>
      <ServicingFilter
        filter={data.filter}
        types={data.types || []}
        handleSearch={handleSearch}
      />
      <hr />
      {data.loading ? (
        <Skeleton height={45} count={10} />
      ) : data.data.length === 0 ? (
        <NoDataFound message={trans("messages.noAddedSubscriptions")} />
      ) : (
        <>
          <div className="table-scroller">
            <table>
              <thead>
                <tr>
                  <th>{trans("tables.contractor")}</th>
                  <th>{trans("tables.category")}</th>
                  <th>{trans("tables.brand")}</th>
                  <th>{trans("tables.model")}</th>
                  <th className="center">
                    {trans("tables.servicingActionsCount")}
                  </th>
                  {/* <th>{trans("tables.invoice")}</th>
                  <th>{trans("tables.paid")}</th> */}
                  {/* <th>{trans("tables.subscription")}</th> */}
                  <th>{trans("tables.dateOfNextServicing")}</th>

                  <th className="right">{trans("tables.price")}</th>
                  <th className="options">{trans("tables.options")}</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((sub) => {
                  return (
                    <tr key={"sub-" + sub.id}>
                      <td>{sub?.subscription?.contractor?.name || "-"}</td>
                      <td>
                        {sub?.subscription?.appliances[0]?.category?.name ||
                          "-"}
                      </td>
                      <td>
                        {sub?.subscription?.appliances[0]?.brand?.name || "-"}
                      </td>
                      <td>
                        {sub?.subscription?.appliances[0]?.appliance_model ||
                          "-"}
                      </td>
                      <td className="center">
                        {sub.servicing_actions.length || 0}
                      </td>
                      {/* <td>
                        {sub.invoice?.number ? (
                          <a
                            href={sub.invoice?.signed_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {`#${sub.invoice?.number}`}
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td
                        style={{
                          color: sub.invoice?.is_paid ? "green" : "red",
                        }}
                      >
                        {sub.invoice?.is_paid ? (
                          <>
                            <img src={checkIcon} alt="completed" /> Платена
                          </>
                        ) : (
                          <>
                            <img src={crossIcon} alt="not completed" />{" "}
                            Неплатена
                          </>
                        )}
                      </td> */}
                      {/* <td>{sub?.subscription?.name || "-"}</td> */}
                      <td>
                        {sub?.next_service_date &&
                        moment(
                          sub.next_service_date,
                          "YYYY-MM-DD",
                        ).isSameOrAfter(moment(), "day")
                          ? (() => {
                              const next = moment(
                                sub.next_service_date,
                                "YYYY-MM-DD",
                              )
                              const days = next.diff(moment(), "days")
                              return `${next.format("DD MMM YYYY")} (${days} ${trans("labels.days")})`
                            })()
                          : "-"}
                      </td>
                      <td className="right">{`${(Number(sub.subscription?.type?.price) || 0).toFixed(2)} ${sub.subscription?.type?.currency_name || ""}`}</td>
                      <td>
                        <ServicingOptions
                          id={sub.id}
                          data={sub}
                          handleEdit={handleEdit}
                          handleDelete={handleDelete}
                        />
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            pages={data.pages}
            page={data.page}
            handlePage={handlePage}
          />
        </>
      )}
    </div>
  )
}
